// extracted by mini-css-extract-plugin
export default {"container":"PagePopup__container--1dD","isWhiteBg":"PagePopup__isWhiteBg--1v_"};